import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, Meta, SafeUrl, Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import {
  ContactFormComponent,
  ExternalLinksComponent,
  TextComponent,
} from '@out-web/components';

@Component({
  selector: 'out-contact',
  standalone: true,
  imports: [
    CommonModule,
    ExternalLinksComponent,
    ContactFormComponent,
    TextComponent,
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent implements OnInit {
  safeMailtoUrl: SafeUrl;
  constructor(
    private meta: Meta,
    private titleService: Title,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    const mailtoUrl = 'mailto:contact@onlyusedtesla.com';
    this.safeMailtoUrl = this.sanitizer.bypassSecurityTrustUrl(mailtoUrl);
  }
  isSubmitted = false;
  ngOnInit(): void {
    this.setMetaData();
    this.routeEvent();
  }

  private setMetaData() {
    this.titleService.setTitle('Contact | Sell Your Tesla | Only Used Tesla');

    this.meta.addTags([
      { property: 'og:title', content: 'Contact | Only Used Tesla' },
    ]);
  }

  private routeEvent() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.url === '/contact') {
        this.isSubmitted = false;
      }
    });
  }

  handleSuccess() {
    this.isSubmitted = true;
    this.router.navigate(['/contact/enquiry-submitted']);
  }
}
